<template>
  <div class="content">
    <div class="topCen" v-if="detail.realPrice">
      <div class="pay-status">
        <section class="success-desc">
          <p class="realprice"><span>{{$t('public.money')}}</span>{{detail.realPrice | filterMoney}}</p><!-- 支付成功 -->
          <p class="top">{{$t('paymentSuccess.successDesc')}}</p><!-- 支付成功 -->
          <p class="btm" v-html="contentText"></p>
        </section>
      </div>
      <div class="pay-info" v-if="detail && ordertype == 4">
        <section class="order-info">
          <p class="item">
            <span class="lf spacing">{{$t('paymentSuccess.orderInfo1')}}</span><!-- 订单编号 -->
            <span class="rt left">{{detail.orderno}}</span>
          </p>
          <p class="item">
            <span class="lf spacing">{{$t('paymentSuccess.orderInfo2')}}</span><!-- 商品名称 -->
            <span class="rt">{{detail.domain}}</span>
          </p>
          <p class="item" v-if="detail.discountprice">
            <span class="lf">{{$t('paymentSuccess.orderInfo4')}}</span><!-- 实付金额 -->
            <span class="rt discountprice">-{{$t('public.money')}}{{detail.discountprice | filterMoney}}</span>
          </p>
        </section>
      </div>
      <div class="pay-info" v-if="detail && ordertype != 4">
        <section class="order-info">
          <p class="item">
            <span class="lf spacing">{{$t('paymentSuccess.orderInfo1')}}</span><!-- 订单编号 -->
            <span class="rt left">{{detail.orderNo}}</span>
          </p>
          <p class="item">
            <span class="lf spacing">{{$t('paymentSuccess.orderInfo2')}}</span><!-- 商品名称 -->
            <span class="rt oh">{{detail.packConfigName}}</span>
          </p>
          <p class="item" v-if="detail.discountPrice">
            <span class="lf">{{$t('paymentSuccess.orderInfo4')}}</span><!-- 实付金额 -->
            <span class="rt discountprice">-{{$t('public.money')}}{{detail.discountPrice | filterMoney}}</span>
          </p>
        </section>
      </div>
    </div>
    <div class="topCen" v-else>
      <div class="pay-status">
        <section class="success-desc">
          <p class="realprice"><span>{{$t('public.money')}}</span>{{detail.realprice | filterMoney}}</p><!-- 支付成功 -->
          <p class="top">{{$t('paymentSuccess.successDesc')}}</p><!-- 支付成功 -->
          <p class="btm" v-html="contentText"></p>
        </section>
      </div>
      <div class="pay-info" v-if="detail && ordertype == 4">
        <section class="order-info">
          <p class="item">
            <span class="lf spacing">{{$t('paymentSuccess.orderInfo1')}}</span><!-- 订单编号 -->
            <span class="rt left">{{detail.orderno}}</span>
          </p>
          <p class="item">
            <span class="lf spacing">{{$t('paymentSuccess.orderInfo2')}}</span><!-- 商品名称 -->
            <span class="rt">{{detail.domain}}</span>
          </p>
          <p class="item" v-if="detail.discountprice">
            <span class="lf">{{$t('paymentSuccess.orderInfo4')}}</span><!-- 实付金额 -->
            <span class="rt discountprice">-{{$t('public.money')}}{{detail.discountprice | filterMoney}}</span>
          </p>
        </section>
      </div>
    </div>
    <section class="pay-next">
      <a class="view-btn" v-if="ordertype != 4" @click="lookDetail">{{$t('paymentSuccess.lookDetail')}}</a><!-- 查看 -->
      <a class="view-btn" v-if="ordertype == 4" @click="mnsSuccess">{{$t('paymentSuccess.lookDetail')}}</a><!-- 查看 -->
      <a class="backToIndex-btn" @click="toIndex">{{$t('paymentSuccess.toIndex')}}</a><!-- 回首页 -->
    </section>
  </div>
</template>

<script>
  let t
  export default {
    name: "boxDetail",
    components: {},
    data() {
      return {
        orderno: "",
        ordertype: "",
        contentText: "",
        detail: ""
      }
    },
    filters: {
      //分转元
      filterMoney(num) {
        return (num / 100).toFixed(2)
      }
    },
    methods: {
      mnsSuccess() {
        this.$router.replace({
          path: '/myMns',
          query: {
            tab: 2,
          }
        })
      },
      goBack() {
        this.$router.replace({
          path: '/profile',
        })
      },
      //回首页
      toIndex() {
        clearInterval(t);
        this.$router.replace({
          path: '/index',
        })
      },
      //查看
      lookDetail() {
        clearInterval(t);
        if (this.ordertype == 1) {
          this.$router.replace({
            path: '/appOpenBox',
            query: {
              orderno: this.orderno,
              source: "box"
            },
          })
        }
      },
      runtime() {
        let time = 3;
        let fn = () => {
          if (time < 0) {
            clearInterval(t);
            t = null;
            if (this.ordertype == 1) {
              this.$router.replace({
                path: '/appOpenBox',
                query: {
                  orderno: this.orderno,
                  source: "box",
                  boxId: this.$route.query.id,
                  boxPath: this.$route.query.boxPath,
                },
              })
            }
          } else {
            if (this.ordertype == 1) {
              this.contentText = '<span>' + time + '</span>' + this.$i18nn.t('paymentSuccess.contentText1') //秒后打开盲盒

            } else if (this.ordertype == 4) {
              this.contentText = '<span>' + time + '</span>' + this.$i18nn.t('paymentSuccess.contentText2') //秒后返回
            } else {
              this.contentText = '<span>' + time + '</span>' + this.$i18nn.t('paymentSuccess.contentText3') //秒查看作品

            }
            time--
          }
        }
        fn()
        t = setInterval(fn, 1000)
      }

    },
    mounted() {
      let that = this;
      if (that.$route.query.orderno) {
        that.orderno = that.$route.query.orderno
      }
      if (that.$route.query.ordertype) {
        that.ordertype = that.$route.query.ordertype
      }

      that.$nextTick(() => {
        that.runtime()
        if (that.ordertype == 1) {
          // 查询盲盒订单的支付成功页面的数据接口
          that.$fetchql.Post('order/paysuccess/info', {
            orderno: that.orderno,
          }).then((res) => {
            console.log(res)
            that.detail = res.data
          })
        } else if (that.ordertype == 2) {
          // 查询作品订单的支付成功页面的数据接口
          that.$fetchql.hasura({
            fn: 'opusorder.querybyorderno',
            variables: {
              orderno: that.orderno,
            }
          }).then((res) => {
            console.log(res)
            that.detail = res.data.packorder[0]
          })
        } else if (that.ordertype == 4) {
          // 查询作品订单的支付成功页面的数据接口
          that.$fetchql.Post('user/domain/order/query', {
            orderno: that.orderno,
          }).then((res) => {
            console.log(res)
            that.detail = res.data
          })
        }


      })

    },
    destroyed() {
      clearInterval(t);
    }
  }

</script>

<style scoped="scoped" lang="less">
  * {
    margin: 0;
    padding: 0;
  }

  /deep/ .mint-button.is-disabled {
    opacity: 1 !important;
    background: #4f5161 !important;
    color: #8d8f9f !important;
    font-weight: bold !important;
    font-size: 18px !important;
  }

  .content {
    padding-top: 56px;
  }

  .ic-arrow-line-leftImg {
    width: 24px;
    height: 24px;
    margin-left: 16px;
    margin-top: 24px;
  }

  .topCen {
    overflow: hidden;
    width: 336px;
    height: 368px;
    margin: 60px auto 0;
    background: url(/static/img/paymentSuc/bg.png);
    background-size: 100% 100%;
    text-align: center;

  }

  .pay-status {
    .btn {
      margin: 0 auto;
      width: 167.5px;
      height: 45px;
      line-height: 45px;
      background: url(/static/img/mns/btn-info.png);
      background-size: 100% 100%;
      font-size: 16px;
      font-weight: 600;
      color: #013925;
    }
  }



  .success-desc .realprice {
    font-family: DINAlternate-Bold, DINAlternate;
    font-size: 35px;
    font-weight: bold;
    color: #f5f4f9;
    text-align: center;
    margin: 80px auto 5px;

    span {
      font-size: 20px;
      padding-right: 5px;
    }
  }

  .success-desc .top {
    font-size: 14px;
    margin-bottom: 8px;
    color: #f5f4f9;
  }

  .success-desc .btm {
    font-size: 11px;
    color: #8d8f9f;
    margin-bottom: 60px;
  }

  .success-desc .btm span {
    color: #4bcfaf;
  }

  .pay-info {
    padding: 0 16px;
  }

  .order-info {
    margin: 24px 0 36px;
  }

  .order-info p.item {
    margin-top: 12px;
    display: flex;
    // align-items: center;
  }

  .order-info span {
    display: inline-block;
    color: #f5f4f9;
    font-size: 13px;
  }

  .order-info span.lf {
    color: #8d8f9f;
    min-width: 75px;
    text-align: left;

    &.spacing {
      letter-spacing: 3.3px;
    }
  }

  .order-info span.rt {
    width: 100%;
    text-align: right;
    margin-left: 30px;
    word-break: break-all;

    &.oh {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &.left {
      text-align: left;
    }

    &.discountprice {
      font-size: 16px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #1CE89E;

      span {
        font-weight: bold;
        color: #1CE89E;
        font-size: 8px;
        padding-right: 2px;
      }
    }
  }

  .pay-next {
    margin-top: 35px;
  }

  .pay-next a {
    display: block;
    margin: 0 auto;
    font-size: 15px;
    text-align: center;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  .pay-next .view-btn {
    width: 332px;
    height: 45px;
    background: url(/static/img/paymentSuc/look-btn.png);
    background-size: 100% 100%;
    line-height: 45px;
    font-weight: bold;
    color: #000000;
  }

  .pay-next .backToIndex-btn {
    color: #666666;
    margin-top: 13px;
  }

</style>



// WEBPACK FOOTER //
// src/views/appModel/paymentSuccess.vue